export default __webpack_public_path__ + "static/media/newsimg2.f529f494.webp";